export const uk = {
    'banners-count': {
        one: '{count} объявление',
        some: '{count} объявления',
        many: '{count} объявлений',
        none: '{count} объявлений'
    }
};
